import { InjectionToken } from '@angular/core';

export const SERVICE_CONFIG_TOKEN = new InjectionToken<ServiceConfig>('SERVICE_CONFIG_TOKEN');

export interface ServiceConfig {
  apiUrl: string;
  logoutRedirectUrl: string;
}

